// Copyright (c) Hamilton Manufacturing Corp.
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const Bar = styled.div`
  width: 100%;
  height: 0.2em;
  animation: BarCountDown linear;
  animation-duration: ${({ time }) => time}s;
`;

const CountDown = ({ type = 'text', time, callback }) => {
  const Ref = useRef(null);
  const [timer, setTimer] = useState('');

  const getTimeRemaining = (deadline) => {
    const total = Date.parse(deadline) - Date.now();
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / 1000 / 60 / 60) % 24);

    if (total <= 0) {
      callback?.();
    }

    return { total, hours, minutes, seconds };
  };

  const startTimer = (deadline) => {
    const { total, minutes, seconds } = getTimeRemaining(deadline);
    if (total >= 0) {
      setTimer(
        `${minutes > 9 ? minutes : '0' + minutes}:${seconds > 9 ? seconds : '0' + seconds}`
      );
    }
  };

  const clearTimer = (deadline) => {
    if (Ref.current) clearInterval(Ref.current);
    startTimer(deadline); // show immediately
    Ref.current = setInterval(() => startTimer(deadline), 1000);
  };

  const getDeadTime = () => {
    const deadline = new Date();
    deadline.setSeconds(deadline.getSeconds() + time);
    return deadline;
  };

  useEffect(() => {
    const deadline = getDeadTime();
    clearTimer(deadline);
    return () => clearInterval(Ref.current); // cleanup
  }, [time]);

  if (type === 'text') return <span>{timer}</span>;
  if (type === 'bar') return <Bar time={time} />;
  return <Bar />;
};

export default CountDown;
